export const en = {
  shrinkToFit: 'Shrink to fit',
  actual: 'Actual size',
  annotate: 'Annotate'
};

export type Type = typeof en;
